'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  body: _react.PropTypes.bool,
  bottom: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  heading: _react.PropTypes.bool,
  left: _react.PropTypes.bool,
  list: _react.PropTypes.bool,
  middle: _react.PropTypes.bool,
  object: _react.PropTypes.bool,
  right: _react.PropTypes.bool,
  tag: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
  top: _react.PropTypes.bool
};

var Media = function Media(props) {
  var body = props.body;
  var bottom = props.bottom;
  var className = props.className;
  var heading = props.heading;
  var left = props.left;
  var list = props.list;
  var middle = props.middle;
  var object = props.object;
  var right = props.right;
  var tag = props.tag;
  var top = props.top;

  var attributes = _objectWithoutProperties(props, ['body', 'bottom', 'className', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);

  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = (0, _classnames2.default)(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  });

  return _react2.default.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes;

exports.default = Media;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/Media.js
 ** module id = 181
 ** module chunks = 0
 **/